import { GetStaticProps, NextPage } from 'next'
import { Layout } from '../../components/layout/layout'
import { REVALIDATION_FREQUENCY } from '../../constants/revalidation'
import { GlobalProps, withLayoutProps } from '../../globals/layout'
import { FAQ, FaqProps } from '../../templates/faq'
import { FaqPageQuery, FaqPageQueryDocument, FaqPageQueryVariables } from '@gql'
import { pageQuery } from '../../utils/pageQuery'

export type FaqPageProps = GlobalProps & {
  data: FaqProps
}

const FaqPage: NextPage<FaqPageProps> = ({ data, ...layoutProps }) => {
  return (
    <Layout { ...layoutProps }>
      <FAQ { ...data } />
    </Layout>
  )
}

export default FaqPage

export const getStaticProps: GetStaticProps = async (context) => {
  const { data } = await pageQuery<FaqPageQuery, FaqPageQueryVariables>({
    query: FaqPageQueryDocument,
  }, context)

  return withLayoutProps({
    path: '/help-and-support/faqs',
  }, data.entry ? {
    props: { data },
    revalidate: REVALIDATION_FREQUENCY,
  } : {
    notFound: true,
  })
}
